module.exports = "/virtual-football-league/img/amblems/right/Spain/Fake_AtleticoMadrid.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/Spain/Fake_AtleticoMadrid.png
// module id = 2149
// module chunks = 4